var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserGroup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 15C32.5 19.1421 29.1421 22.5 25 22.5C20.8579 22.5 17.5 19.1421 17.5 15C17.5 10.8579 20.8579 7.5 25 7.5C29.1421 7.5 32.5 10.8579 32.5 15Z",
    fill: "#214253"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45 20C45 22.7614 42.7614 25 40 25C37.2386 25 35 22.7614 35 20C35 17.2386 37.2386 15 40 15C42.7614 15 45 17.2386 45 20Z",
    fill: "#214253"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35 37.5C35 31.9772 30.5228 27.5 25 27.5C19.4772 27.5 15 31.9772 15 37.5V45H35V37.5Z",
    fill: "#214253"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 20C15 22.7614 12.7614 25 10 25C7.23858 25 5 22.7614 5 20C5 17.2386 7.23858 15 10 15C12.7614 15 15 17.2386 15 20Z",
    fill: "#214253"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40 45V37.5C40 34.8646 39.3204 32.388 38.1268 30.2358C38.7256 30.0819 39.3532 30 40 30C44.1421 30 47.5 33.3579 47.5 37.5V45H40Z",
    fill: "#214253"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8732 30.2358C10.6796 32.388 10 34.8646 10 37.5V45H2.5V37.5C2.5 33.3579 5.85786 30 10 30C10.6468 30 11.2744 30.0819 11.8732 30.2358Z",
    fill: "#214253"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserGroup);
export default __webpack_public_path__ + "static/media/user-group.267abd944751eeb914137b75fffd7078.svg";
export { ForwardRef as ReactComponent };